<template>
  <div>
    <el-dialog
        :title="'Xuất file tổng hợp điểm danh'"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <el-form
          label-width="200px"
          :model="dataInput"
          label-position="left"
          :rules="rules"
          ref="dataInput"
      >
        <el-form-item label="Chọn ngày">
          <el-date-picker
              v-model="dateStartEnd"
              type="daterange"
              unlink-panels
              style="width: 300px"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              value-format="yyyy-MM-dd"
              format="dd-MM-yyyy"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Chọn kiểu" style="width: 100%">
          <el-radio-group v-model="dataInput.type">
            <el-radio :label="true">Toàn bộ trường</el-radio>
            <el-radio :label="false">Theo phòng ban</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="dataInput.type == false" label="Chọn phòng ban" style="width: 100%">
          <el-select v-model="dataInput.idDepartment" clearable placeholder="Chọn phòng ban" style="width: 300px">
            <el-option
                v-for="(item,index) in departmentList"
                :key="index"
                :label="item.departmentName"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Trạng thái" prop="status">
          <!-- chọn trạng thái -->
          <el-select
              clearable
              class="button-left-status"
              v-model="dataInput.status"
              placeholder="Trạng thái"
              style="width: 300px"
          >
            <el-option
                v-for="item in employeeStatusList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close" />
          <span>{{ $t("button.close") }}</span>
        </el-button>

        <el-button
            v-if="this.dateStartEnd.length == 0 || this.dataInput.status == null"
            type="success"
            size="medium"
            disabled
            :loading="loadingButton"
            mini
        >
          <i class="el-icon-circle-check" />
          <span>Xuất file</span>
        </el-button>

        <el-button
            v-else
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm()"
        >
          <i class="el-icon-circle-check" />
          <span>Xuất file</span>
        </el-button>
      </span>
    </el-dialog>
    <PeopleTypeCreate
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {kidStatusList} from "@/constant/listCommon";
import PeopleTypeCreate from "@/views/cashinternal/PeopleTypeCreate.vue";
import shiftMaster from "@/services/ShiftMaster";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import {exportAttendanceSummaryV3MonthExcel} from "@/commonFuncion/exportAttendanceSummaryV3MonthExcel";

export default {
  components: {PeopleTypeCreate},
  props: {
    dialogVisible: null,
    targetType: {
      type: String,
      default: () => ""
    },
    teamType: {
      type: String,
      default: () => ""
    }
  },

  data() {
    return {
      employeeStatusList: [
        { key: "Đang làm", value: "Đang làm" },
        { key: "Tạm nghỉ", value: "Tạm nghỉ" },
        { key: "Nghỉ làm", value: "Nghỉ làm" },
      ],
      kidStatusList,
      dateStartEnd: [],
      value1: [],
      textarea: "",
      typeInternalList: [],
      pickerOptions: {},
      selectDate: "",
      dataInput: {
        type: true,
        idDepartment: "",
        status: "",
      },
      showCreateDialog: false,
      loadingButton: false,
      //css excel
      styleCols1: [],
      styleCols2: [],
      nameCol: {
        name: "",
        style: "",
        numberMerges: 1,
      },
    };
  },
  created() {
    this.$store.dispatch('departmentStore/fetchDataDepartmentList')
  },
  computed: {
    ...mapGetters('departmentStore', ['departmentList']),
  },
  methods: {
    submitForm() {
      if (this.dataInput.type == true) {
        this.dataInput.idDepartment = "";
      }
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        const startDate = this.dateStartEnd?.[0] || null;
        const endDate   = this.dateStartEnd?.[1] || null;
        shiftMaster.getSummaryExel(
            this.dataInput.idDepartment,
            this.$props.teamType,
            this.$props.targetType,
            startDate,
            endDate,
            this.dataInput.status
        )
            .then((resp) => {
              console.log(resp.data.data);
              exportAttendanceSummaryV3MonthExcel(resp.data.data, "TEACHER")
            })
            .catch((err) => {
              console.log(err);
              NotifyMessage.leftCornerNotificationError("Thất bại")
            });
      });
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.dateStartEnd = [];
        this.dataInput.status = "";
        this.dataInput.idDepartment = "";
        this.dataInput.type = true;
      }, 300);
    },
  },

  // beforeMount() {
  //
  //   this.getCurrentDate();
  // },
};
</script>

<style lang="scss" scoped></style>
